<!-- ======= Workspace Sidebar Shell (Start) ======= -->
@if (showSidebar) {
  <app-sidebar></app-sidebar>
}
<!-- ======= Workspace Sidebar Shell (End) ======= -->

<!-- ======= Workspace Page Outlet (Start) ======= -->
<router-outlet></router-outlet>
<!-- ======= Workspace Page Outlet (End) ======= -->
